import { render, staticRenderFns } from "./TipoLocalArmazenamentoList.vue?vue&type=template&id=0b741597"
import script from "./TipoLocalArmazenamentoList.vue?vue&type=script&lang=js"
export * from "./TipoLocalArmazenamentoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports